import { render, staticRenderFns } from "./MandatsModel.vue?vue&type=template&id=9833b0c0&"
import script from "./MandatsModel.vue?vue&type=script&lang=js&"
export * from "./MandatsModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports